<sw-page class="topdata-es-synonym-source-list-page">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" @click="onAddSource">
            {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.buttonAdd') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :dataSource="items"
            :columns="columns"
            :repository="repository"
            identifier="topdata-es-synonym-source"
            :show-settings="true"
            :show-selection="false"
            :allow-view="false"
            :allow-edit="false"
            :allow-delete="false"
            :allow-inline-edit="false"
            :full-page="true"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            :is-loading="isLoading"
            @page-change="onPageChange"
            @column-sort="onSortColumn"
        >
            <template #column-language="{ item }">
                {{ item.language || $tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.languageGlobal') }}
            </template>

            <template #column-active="{ item }">
                <sw-icon
                    :name="item.active ? 'regular-checkmark-xs' : 'regular-times-xs'"
                    :color="item.active ? '#37d046' : '#de294c'"
                />
            </template>

            <template #column-lastImportAt="{ item }">
                <template v-if="item.lastImportAt">
                    <sw-time-ago :date="item.lastImportAt" />
                    <span v-if="item.lastImportStatus"> ({{ item.lastImportStatus }})</span>
                </template>
                <template v-else>
                    {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.neverImported') }}
                </template>
            </template>

            <template #actions="{ item }">
                <sw-context-menu-item @click="onEditSource(item)">
                    {{ $tc('global.default.edit') }}
                </sw-context-menu-item>
                <sw-context-menu-item
                    :disabled="importingId === item.id"
                    @click="onImport(item, false)"
                >
                    {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.buttonImportNow') }}
                </sw-context-menu-item>
                <sw-context-menu-item
                    :disabled="importingId === item.id"
                    @click="onImport(item, true)"
                >
                    {{ $tc('TopdataEnhancedSearchSW6.topdata-es-synonym-source.buttonDryRun') }}
                </sw-context-menu-item>
                <sw-context-menu-item variant="danger" @click="onShowDeleteModal(item)">
                    {{ $tc('global.default.delete') }}
                </sw-context-menu-item>
            </template>
        </sw-entity-listing>

        <topdata-es-synonym-source-form
            v-if="activeModal"
            :entity="currentEntity"
            :repository="repository"
            @save="onCloseModal"
            @cancel="onCloseModal"
        />

        <sw-confirm-modal
            v-if="showDeleteModal"
            :title="$tc('global.default.delete')"
            :text="deleteConfirmText"
            :confirmButtonVariant="'danger'"
            @confirm="onConfirmDelete"
            @close="onCloseDeleteModal"
            @cancel="onCloseDeleteModal"
        />
    </template>
</sw-page>
